jQuery(document).ready(function ($) {
  var webyzeMultiProductColorsRunningCall=!1,webyzeMultiProductColorsQueuedCall=!1;window.webyzeMultiProductColorsLoad=function(){var $ = window.jQuery;function q(f,d){var c=f[0],a=f[1],b=f[2],e=f[3];c=h(c,a,b,e,d[0],7,-680876936);e=h(e,c,a,b,d[1],12,-389564586);b=h(b,e,c,a,d[2],17,606105819);a=h(a,b,e,c,d[3],22,-1044525330);c=h(c,a,b,e,d[4],7,-176418897);e=h(e,c,a,b,d[5],12,1200080426);b=h(b,e,c,a,d[6],17,-1473231341);a=h(a,b,e,c,d[7],22,-45705983);c=h(c,a,b,e,d[8],7,1770035416);e=h(e,c,a,b,d[9],12,-1958414417);b=h(b,e,c,a,d[10],17,-42063);a=h(a,b,e,c,d[11],22,-1990404162);c=h(c,a,b,e,d[12],7,1804603682);e=h(e,c,a,b,d[13],12,-40341101);b=h(b,e,c,a,d[14],17,-1502002290);a=h(a,b,e,c,d[15],22,1236535329);c=k(c,a,b,e,d[1],5,-165796510);e=k(e,c,a,b,d[6],9,-1069501632);b=k(b,e,c,a,d[11],14,643717713);a=k(a,b,e,c,d[0],20,-373897302);c=k(c,a,b,e,d[5],5,-701558691);e=k(e,c,a,b,d[10],9,38016083);b=k(b,e,c,a,d[15],14,-660478335);a=k(a,b,e,c,d[4],20,-405537848);c=k(c,a,b,e,d[9],5,568446438);e=k(e,c,a,b,d[14],9,-1019803690);b=k(b,e,c,a,d[3],14,-187363961);a=k(a,b,e,c,d[8],20,1163531501);c=k(c,a,b,e,d[13],5,-1444681467);e=k(e,c,a,b,d[2],9,-51403784);b=k(b,e,c,a,d[7],14,1735328473);a=k(a,b,e,c,d[12],20,-1926607734);c=g(a^b^e,c,a,d[5],4,-378558);e=g(c^a^b,e,c,d[8],11,-2022574463);b=g(e^c^a,b,e,d[11],16,1839030562);a=g(b^e^c,a,b,d[14],23,-35309556);c=g(a^b^e,c,a,d[1],4,-1530992060);e=g(c^a^b,e,c,d[4],11,1272893353);b=g(e^c^a,b,e,d[7],16,-155497632);a=g(b^e^c,a,b,d[10],23,-1094730640);c=g(a^b^e,c,a,d[13],4,681279174);e=g(c^a^b,e,c,d[0],11,-358537222);b=g(e^c^a,b,e,d[3],16,-722521979);a=g(b^e^c,a,b,d[6],23,76029189);c=g(a^b^e,c,a,d[9],4,-640364487);e=g(c^a^b,e,c,d[12],11,-421815835);b=g(e^c^a,b,e,d[15],16,530742520);a=g(b^e^c,a,b,d[2],23,-995338651);c=l(c,a,b,e,d[0],6,-198630844);e=l(e,c,a,b,d[7],10,1126891415);b=l(b,e,c,a,d[14],15,-1416354905);a=l(a,b,e,c,d[5],21,-57434055);c=l(c,a,b,e,d[12],6,1700485571);e=l(e,c,a,b,d[3],10,-1894986606);b=l(b,e,c,a,d[10],15,-1051523);a=l(a,b,e,c,d[1],21,-2054922799);c=l(c,a,b,e,d[8],6,1873313359);e=l(e,c,a,b,d[15],10,-30611744);b=l(b,e,c,a,d[6],15,-1560198380);a=l(a,b,e,c,d[13],21,1309151649);c=l(c,a,b,e,d[4],6,-145523070);e=l(e,c,a,b,d[11],10,-1120210379);b=l(b,e,c,a,d[2],15,718787259);a=l(a,b,e,c,d[9],21,-343485551);f[0]=c+f[0]&4294967295;f[1]=a+f[1]&4294967295;f[2]=b+f[2]&4294967295;f[3]=e+f[3]&4294967295}function g(f,d,c,a,b,e){d=(d+f&4294967295)+(a+e&4294967295)&4294967295;return(d<<b|d>>>32-b)+c&4294967295}function h(f,d,c,a,b,e,m){return g(d&c|~d&a,f,d,b,e,m)}function k(f,d,c,a,b,e,m){return g(d&a|c&~a,f,d,b,e,m)}function l(f,d,c,a,b,e,m){return g(c^(d|~a),f,d,b,e,m)}function r(f){txt="";var d=f.length,c=[1732584193,-271733879,-1732584194,271733878],a;for(a=64;a<=f.length;a+=64){var b,e=f.substring(a-64,a),m=[];for(b=0;64>b;b+=4)m[b>>2]=e.charCodeAt(b)+(e.charCodeAt(b+1)<<8)+(e.charCodeAt(b+2)<<16)+(e.charCodeAt(b+3)<<24);q(c,m)}f=f.substring(a-64);b=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(a=0;a<f.length;a++)b[a>>2]|=f.charCodeAt(a)<<(a%4<<3);b[a>>2]|=128<<(a%4<<3);if(55<a)for(q(c,b),a=0;16>a;a++)b[a]=0;b[14]=8*d;q(c,b);return c}function t(f){for(var d=0;d<f.length;d++){for(var c=d,a=f[d],b="",e=0;4>e;e++)b+=u[a>>8*e+4&15]+u[a>>8*e&15];f[c]=b}return f.join("")}var n=function(){var f={'"':"&quot;","&":"&amp;","<":"&lt;",">":"&gt;"};return function(d){return d.replace(/["&<>]/g,function(c){return f[c]})}}(),p=$(".webyze-multi-product-colors:not(.webyze-loaded)").map(function(){return $(this).attr("data-product-id")}).get();if(p&&0!=p.length)if(webyzeMultiProductColorsRunningCall)webyzeMultiProductColorsQueuedCall=!0;else{webyzeMultiProductColorsRunningCall=!0;webyzeMultiProductColorsQueuedCall=!1;var u="0123456789abcdef".split("");t(r("hello"));var v="shop="+Shopify.shop+p.map(function(f){return"&prodId[]="+f}).join("");$.ajax({method:"GET",url:"https://s-pc.webyze.com/ProductColors/productGroup-"+t(r(v))+"?"+v,dataType:"json"}).done(function(f){Array.isArray(f)&&(f=f.map(function(d){return JSON.parse(d)}),f.forEach(function(d){if(Array.isArray(d)){d.map(function(a){return a.id});var c="";d.forEach(function(a){c+='<span class="swatchProductColor swatchType_'+a.type+'" data-name="'+n(a.name)+'" data-handle="'+n(a.handle)+'" data-image="'+n(a.image)+'">';if(window.webyzeProductColors_useProdImage)c+="<div style=\"background-image: url('"+a.image.replace(/\.(png|jpg|jpeg|bmp)/,window.webyzeProductColors_prodImageLarge?"_large.$1":"_small.$1")+"');background-size: cover;\"></div>";else switch(a.type){case "two_colors":a.data=a.data.split("|");c+='<div><div style="background:'+a.data[0]+';"></div><div style="background:'+a.data[1]+';"></div></div>';break;case "image":c+="<div style=\"background-image: url('https://s-pc.webyze.com/ProductColors/uploads/"+a.data+"');\"></div>";break;default:c+='<div style="background:'+a.data+';"></div>'}c+='<span class="webyzeTooltip"><span></span><span class="innerText">'+n(a.name)+"</span><span></span></span></span>"});$(d.map(function(a){return'.webyze-multi-product-colors[data-product-id="'+a.id+'"]'}).join(", ")).addClass("webyze-loaded").html(c)}}),$(".webyze-multi-product-colors").find(".swatchProductColor").on("click",function(d){d.preventDefault();window.location.href="/products/"+$(this).data("handle")}).on("mouseenter",function(){var d=$(this).attr("data-image").replace(/\.(jpg|png|jpeg)/,"_large.$1");0===d.indexOf("https://")&&$(this).parent().parent().parent().find("img").attr("src",d).attr("srcset",d)}),$(p.map(function(d){return'.webyze-multi-product-colors[data-product-id="'+d+'"]'}).join(", ")).addClass("webyze-loaded"))}).fail(function(){}).always(function(){webyzeMultiProductColorsRunningCall=!1;webyzeMultiProductColorsQueuedCall&&window.webyzeMultiProductColorsLoad()})}};
  // window.webyzeMultiProductColorsLoad();
  window.webyzeMultiProductColorsLoad && window.webyzeMultiProductColorsLoad();
  let cartPopupActive = false;
  let menuDrawerActive = false;
  let toggleFooterActive = false;

  function handleResize() {
    const isTablet = $(window).innerWidth() < 1201;
    const isMobile = $(window).innerWidth() < 769;

    if (isTablet) {
      if (!cartPopupActive) {
        $(".header-cart .dropdown-toggle").on("click", cartPopup);
        cartPopupActive = true;
      }
      if (!menuDrawerActive) {
        $(".header-middle-block .stackbar").on("click", menuDrawerPopup);
        menuDrawerActive = true;
      }
      if (!toggleFooterActive) {
        $(".rt-footer .toogle-section .tt-collapse-title").on(
          "click",
          toggleFooterLinks
        );
        toggleFooterActive = true;
      }

      // Ensure the LAST footer accordion is open on load / resize for tablet & mobile
      const $lastFooterTitle = $(".rt-footer .toogle-section .tt-collapse-title").last();
      if ($lastFooterTitle.length) {
        $lastFooterTitle.addClass("tt-open");
        $lastFooterTitle.next(".tt-collapse-content").show();
      }
    } else {
      if (cartPopupActive) {
        $(".header-cart .dropdown-toggle").off("click", cartPopup);
        cartPopupActive = false;
        $(".header-cart .dropdown-menu").removeClass("open");
      }
      if (menuDrawerActive) {
        $(".header-middle-block .stackbar").off("click", menuDrawerPopup);
        menuDrawerActive = false;
        $(".mobile_menu").removeClass("open");
      }
      if (toggleFooterActive) {
        $(".rt-footer .toogle-section .tt-collapse-title").off(
          "click",
          toggleFooterLinks
        );
        toggleFooterActive = false;
        $(".rt-footer .toogle-section .tt-collapse-title").removeClass(
          "tt-open"
        );
        $(".rt-footer .toogle-section .tt-collapse-content").show();
      }
    }
  }

  $(window).on("resize", handleResize);
  handleResize();

  init();
  function init() {
    addToCartForm();
    removeFromCartForm();
  }

  function cartPopup(e) {
    e.preventDefault();
    $(".header-cart .dropdown-menu").toggleClass("open");
    const cartPopupOpen = $(".header-cart .dropdown-menu").hasClass("open");
    if (cartPopupOpen) {
      $(".header-cart .dropdown-menu .close").on("click", function (e) {
        e.preventDefault();
        $(".header-cart .dropdown-menu").removeClass("open");
      });
    }
  }

  function menuDrawerPopup(e) {
    e.preventDefault();
    $(".mobile_menu").toggleClass("open");
    const menuDrawerOpen = $(".mobile_menu").hasClass("open");
    if (menuDrawerOpen) {
      $(".mobile_menu .stackbarClose .close").on("click", function (e) {
        e.preventDefault();
        $(".mobile_menu").removeClass("open");
      });
    }
  }

  function toggleFooterLinks(event) {
    event.preventDefault();
    const target = $(event.target);
    const content = target.next(".tt-collapse-content");
    content.slideToggle();
    target.toggleClass("tt-open");
  }

  if ($(".sub-menu-block.tab ul.tabs li").length > 0) {
    $(".sub-menu-block.tab ul.tabs li").hover(function () {
      var tab_id = $(this).attr("data-tab");
      $(".sub-menu-block.tab ul.tabs li").removeClass("current");
      $(".tab-content").removeClass("current");
      $(this).addClass("current");
      $(".sub-menu-block.tab #" + tab_id).addClass("current");
    });
  }

  $(document).on("click", function (event) {
    const target = $(event.target);
    if (target.hasClass("sub__close")) {
      event.preventDefault();
      target.parent().parent().removeClass("is-active");
    }
  });

  $(".nav__link").on("click", function (event) {
    const subMenu = $(this).next();
    if (subMenu && subMenu.hasClass("nav__sub")) {
      event.preventDefault();
      subMenu.addClass("is-active");
    }
  });

  $(".has-dropdown").on("click", function () {
    const submenu = $(this).find(".submenu");
    if (submenu.length) {
      submenu.toggle();
    }
  });

  let desktop_menu = $(".desktop_menu");
  let stickyHeader = desktop_menu.offset().top;
  function handleScroll() {
    if ($(window).scrollTop() >= stickyHeader) {
      desktop_menu.addClass("sticky");
    } else {
      desktop_menu.removeClass("sticky");
    }
  }
  $(window).scroll(handleScroll);

  function resolveSelectedVariantId(formEl) {
    try {
      if (!formEl) return null;

      const card = formEl.closest(".rt-product-card");
      if (card) {
        const cardChecked = card.querySelector(
          '.tt-options-swatch input[type="radio"]:checked'
        );
        const cardVarId = cardChecked?.getAttribute("var_id");
        if (cardVarId) return cardVarId.toString();
      }

      const productMain = document.querySelector(".product-main");
      if (productMain && window.productJson) {
        const variants = JSON.parse(window.productJson);
        const selectedValues = [];
        const requiredOptionIdxs = new Set();
        const mainSwatchInputs = Array.from(
          productMain.querySelectorAll('.tt-options-swatch input[type="radio"]')
        ).filter((input) => !input.closest(".rt-product-card"));

        mainSwatchInputs.forEach((el) => {
          const optionIndex = el.getAttribute("optionIndex");
          if (!optionIndex) return;
          const idx = parseInt(optionIndex.replace("option", ""), 10) - 1;
          if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
            requiredOptionIdxs.add(idx);
          }
        });

        mainSwatchInputs
          .filter((input) => input.checked)
          .forEach((input) => {
            const optionIndex = input.getAttribute("optionIndex");
            const value = (input.value || "").toString();
            if (!value) return;
            if (optionIndex) {
              const idx = parseInt(optionIndex.replace("option", ""), 10) - 1;
              if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                selectedValues[idx] = value;
              }
            }
          });

        for (const idx of requiredOptionIdxs) {
          if (!selectedValues[idx]) return null;
        }

        const normalize = (str) => (str || "").toString().trim().toLowerCase();
        const matchingVariant = variants.find((v) => {
          if (selectedValues[0] && normalize(v.option1) !== normalize(selectedValues[0])) return false;
          if (selectedValues[1] && normalize(v.option2) !== normalize(selectedValues[1])) return false;
          if (selectedValues[2] && normalize(v.option3) !== normalize(selectedValues[2])) return false;
          return true;
        });
        if (matchingVariant?.id) return matchingVariant.id.toString();
      }

      const currentInputValue = formEl.querySelector('input[name="id"]')?.value;
      return currentInputValue ? currentInputValue.toString() : null;
    } catch (e) {
      const fallbackValue = formEl?.querySelector('input[name="id"]')?.value;
      return fallbackValue ? fallbackValue.toString() : null;
    }
  }

  function addToCartForm() {
    $(".add-to-cart-form")
      .off("submit.globalAtc")
      .on("submit.globalAtc", async function (event) {
      if ($(this).closest(".product-recommendations").length > 0) return;
      event.preventDefault();
      try {
        const resolvedVariantId = resolveSelectedVariantId(this);
        if (resolvedVariantId) {
          $(this).find('input[name="id"]').val(resolvedVariantId);
        }
        loading(true);
        const response = await postAjax(
          "/cart/add.js",
          "POST",
          "json",
          $(this).serialize()
        );
        const itemImageUrl = response.featured_image.url;
        const itemTitle = response.title;
        // const itemQty = response.quantity;
        const itemQty = parseInt($(this).find(".qty-value").val());
        // const itemTotalPrice = getItemFormatedPrice(response.price);
        const itemTotalPrice = getItemFormatedPrice(response.price * itemQty);
        const cartQty =
          parseInt(window.cart.quantity) +
          parseInt($(this).find(".qty-value").val());
        const cartTotalPriceWithoutFormatedPrice =
          parseInt(window.cart.total_price) +
          parseInt(response.price) * parseInt($(this).find(".qty-value").val());
        const cartTotalPrice = getItemFormatedPrice(
          cartTotalPriceWithoutFormatedPrice
        );
        await layoutUpdate();
        $("#modal-addtocart .addtocart-product img").attr("src", itemImageUrl);
        $("#modal-addtocart .addtocart-product .product-title").text(itemTitle);
        $("#modal-addtocart .addtocart-product .addtocart-qty .count").text(
          itemQty
        );
        $("#modal-addtocart .product-cart-total .price-amt").text(
          itemTotalPrice
        );
        // $('#modal-addtocart .product-cart-price-total .modal-total-quantity').text(cartQty);
        // $('#modal-addtocart .product-cart-price-total .price').text(cartTotalPrice);
        setTimeout(function () {
          // window.cart.quantity = cartQty;
          // window.cart.total_price = cartTotalPriceWithoutFormatedPrice;
          removeFromCartForm();
          loading(false);
          $("#modal-addtocart").addClass("active");
          $("html").addClass("modal-addtocart-active");
          if ($("#modal-addtocart").hasClass("active")) {
            $(".modal-addtocart-header .close").click(function () {
              $("#modal-addtocart").removeClass("active");
              $("html").removeClass("modal-addtocart-active");
            });

            $("#modal-addtocart .modal-addtocart-overlay").click(function () {
              $("#modal-addtocart").removeClass("active");
              $("html").removeClass("modal-addtocart-active");
            });
          }
        }, 1000);
        // console.log('Added item to cart....!');
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });
    onChangeQty();
  }

  function removeFromCartForm() {
    $(".header_delete_cartitem_js").click(async function (event) {
      event.preventDefault();
      const href = $(this).attr("href");
      const urlParams = new URLSearchParams(href.split("?")[1]);
      var cartUpdates = {};
      cartUpdates[urlParams.get("id")] = parseInt(urlParams.get("quantity"));
      try {
        const response = await postAjax("/cart/update.js", "POST", "json", {
          updates: cartUpdates,
        });
        await layoutUpdate();
        setTimeout(function () {
          removeFromCartForm();
        }, 1000);
        console.log("Removed item from cart....!");
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });
  }

  function onChangeQty() {
    // Quantity update for regular product
    $(".qty-wrapper .qty-btn").click(function () {
      console.log("click");
      const inputQty = $(this).parent().find("input.qty-input_box");
      const currentQty = parseInt(inputQty.val());
      if ($(this).hasClass("plus-btn")) {
        inputQty.val(Math.max(currentQty + 1, 1));
      } else {
        inputQty.val(Math.max(currentQty - 1, 1));
      }
    });

    if ($(".cart-qty-wrapper .qty-btn").length > 0) {
      $(".cart-qty-wrapper .qty-btn").click(async function () {
        const inputQtyCart = $(this).parent().find("input.qty-input_box");
        const currentQtyCart = parseInt(inputQtyCart.val());
        const currentId = inputQtyCart.attr("id").replace("updates_", "");
        const cartUpdates = {};

        if ($(this).hasClass("plus-btn")) {
          loading(true);
          inputQtyCart.val(Math.max(currentQtyCart + 1, 1));
          cartUpdates[currentId] = parseInt(currentQtyCart + 1);
          await cartlayoutUpdate({ updates: cartUpdates });
        } else {
          loading(true);
          inputQtyCart.val(Math.max(currentQtyCart - 1, 1));
          cartUpdates[currentId] = parseInt(currentQtyCart - 1);
          await cartlayoutUpdate({ updates: cartUpdates });
        }
      });
    }
  }

  async function postAjax(url, method, dataType, data) {
    const params = {
      type: method,
      url: url,
      data: data,
      dataType: dataType,
    };
    return await $.ajax(params);
  }

  async function getAjax(url, method, dataType) {
    const params = {
      type: method,
      url: url,
      dataType: dataType,
    };
    const response = await $.ajax(params);
    return response;
  }

  async function layoutUpdate() {
    try {
      const response = await getAjax(window.location.href, "GET", "html");
      let headercartUpdate = $(response).find(".header-cart").html();
      $(".header-cart").html(headercartUpdate);
    } catch (error) {
      console.error("Error loading more content:", error);
      loading(false);
    }
  }

  async function cartlayoutUpdate(data) {
    try {
      await postAjax("/cart/update.js", "POST", "json", data);
      const response = await getAjax(window.location.href, "GET", "html");
      let cartlayout = $(response).find(".main_cart-section").html();
      $(".main_cart-section").html(cartlayout);
      let headercartUpdate = $(response).find(".header-cart").html();
      $(".header-cart").html(headercartUpdate);
      discountToggle();
      onChangeQty();
      loading(false);
    } catch (error) {
      console.error("Error loading more content:", error);
      loading(false);
    }
  }

  // Collection Page

  if (
    $("body").hasClass("pagecollection") ||
    $("body").hasClass("pagesearch")
  ) {
    filterLoad();
    function filterLoad() {
      if (".pagecollection .filter-title") {
        $(".pagecollection .filter-title").click(function (e) {
          e.preventDefault();
          $(this).toggleClass("active");
          $(this).next(".filter-content").slideToggle();
        });
      }

      $(".filters-options .btn-toggle").click(function () {
        $("#filter-sidebar").addClass("filter-active");
        $("html").addClass("filter--active");
      });
      $(".filter-mobile-header").click(function () {
        $("#filter-sidebar").removeClass("filter-active");
        $("html").removeClass("filter--active");
      });
    }

    function updateItemView() {
      const isMobile = $(window).innerWidth() < 769;
      const currentView = localStorage.getItem("item_view");

      if (isMobile) {
        if (currentView !== "list") {
          localStorage.setItem("item_view", "list");
        }
      } else {
        if (currentView !== "grid") {
          localStorage.setItem("item_view", "grid");
        }
      }

      if (localStorage.getItem("item_view") == "list") {
        listView();
      }
      if (localStorage.getItem("item_view") == "grid") {
        gridView();
      }
      $(".collection-main__wrapper .quantity.view .col-one").click(function (
        e
      ) {
        e.preventDefault();
        if (localStorage.getItem("item_view") == "grid") {
          loading(true);
          setTimeout(function () {
            localStorage.setItem("item_view", "list");
            listView();
          }, 1500);
        }
      });
      $(".collection-main__wrapper .quantity.view .col-three").click(function (
        e
      ) {
        e.preventDefault();
        if (localStorage.getItem("item_view") == "list") {
          loading(true);
          setTimeout(function () {
            localStorage.setItem("item_view", "grid");
            gridView();
          }, 1500);
        }
      });
    }
    function gridView() {
      $(".collection-main__wrapper .quantity.view .col-three").addClass(
        "active"
      );
      $(".collection-main__wrapper .quantity.view .col-one").removeClass(
        "active"
      );
      $(".products").removeClass("list").addClass("grid");
      $(".products .col-item").removeClass("col-md-12").addClass("col-md-6");
      $(".products .col-item").removeClass("col-12").addClass("col-6");
      loading(false);
    }
    function listView() {
      $(".collection-main__wrapper .quantity.view .col-one").addClass("active");
      $(".collection-main__wrapper .quantity.view .col-three").removeClass(
        "active"
      );
      $(".products").removeClass("grid").addClass("list");
      $(".products .col-item").removeClass("col-md-6").addClass("col-md-12");
      $(".products .col-item").removeClass("col-6").addClass("col-12");
      loading(false);
    }

    function updateURLParameter(url, newKey, newValue) {
      let urlObj = new URL(url);
      urlObj.searchParams.set(newKey, newValue);
      return urlObj.toString();
    }

    updateItemView();
    $("select.sort-position").on("change", async function (event) {
      loading(true);
      let selectedValue = $(this).val();
      let newUrl = updateURLParameter(
        window.location.href,
        "sort_by",
        selectedValue
      );
      try {
        let productRes = await getAjax(newUrl, "GET", "html");
        let gridUpdate = $(productRes).find(".products").html();
        $(".products").html(gridUpdate);
        updateItemView();
        addToCartForm();
        onChangeVariantPLP();
        window.history.pushState({ path: newUrl }, "", newUrl);
        loading(false);
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });

    function onChangeVariantPLP() {
      if ($(".tt-swatches-container").length > 0) {
        $('.tt-options-swatch input[type="radio"]').change(async function () {
          let selectedValue = $(this).val();
          let var_id = $(this).attr("var_id");
          $(this)
            .closest(".rt-product-card__details")
            .find('.add-to-cart-form [name="id"]')
            .val(var_id);

          if(typeof Globo != 'undefined' && typeof Globo?.Preorder != 'undefined'){
            $(this).closest('.card-bottom-desc')?.find('form.gridProductPreOrderForm.preorderLoaded')?.removeClass('preorderLoaded');
            Globo?.Preorder?.initCollection();
          }
        });
      }
    }

    onChangeVariantPLP();
    // Infinite Scroll START
    if($('.collection-main__wrapper .rt-collection-products.infinite_scroll').length > 0){
      var endlessScroll = new Ajaxinate({
        container: '#Huratips-Loop',
        pagination: '#Huratips-Pagination'
      });
    }
    // var page = 2;
    // var isLoading = false;
    // async function loadMoreContent() {
    //   if (isLoading) return;
    //   isLoading = true;
    //   let newUrl = updateURLParameter(window.location.href, "page", page);

    //   try {
    //     loading(true);
    //     let productRes = await getAjax(newUrl, "GET", "html");
    //     let gridUpdate = $(productRes).find(".rt-collection-products").html();
    //     if (gridUpdate.trim() !== "") {
    //       $(".rt-collection-products").append(gridUpdate);
    //       updateItemView();
    //       addToCartForm();
    //       onChangeVariantPLP();
    //       page++;
    //       isLoading = false;
    //       loading(false);
    //     } else {
    //       isLoading = true;
    //       loading(false);
    //       return;
    //     }
    //   } catch (error) {
    //     console.error("Error loading more content:", error);
    //     isLoading = false;
    //     loading(false);
    //   }
    // }

    // if($('.collection-main__wrapper .rt-collection-products.infinite_scroll').length > 0){
    //   $(window).scroll(function() {
    //     if ($(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
    //       loadMoreContent();
    //     }
    //   });
    // }

    // Infinite Scroll END

    // facets-form ajax START
    removeFilter();
    $(".facets-form").change(function () {
      $(this).submit();
    });

    $(".facets-form").submit(async function (event) {
      event.preventDefault();
      var formData = $(this).serialize();
      var newUrl =
        window.location.origin + window.location.pathname + "?" + formData;

      try {
        loading(true);
        const productRes = await getAjax(newUrl, "GET", "html");
        let gridUpdate = $(productRes).find(".products").html();
        $(".products").html(gridUpdate);
        let facetsForm = $(productRes).find(".facets-form").html();
        $(".facets-form").html(facetsForm);
        history.replaceState(null, null, newUrl);
        updateItemView();
        addToCartForm();
        onChangeVariantPLP();
        filterLoad();
        removeFilter();
        loading(false);
      } catch {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });

    function removeFilter() {
      if ($(".facets-form .selected-all .selected-filter").length > 1) {
        $(".facets-form .selected-all .selected-filter.clear_all").show();
      } else {
        $(".facets-form .selected-all .selected-filter.clear_all").hide();
      }
      $(".facets-form .selected-filter a").click(async function (e) {
        e.preventDefault();
        const linkUrl = window.location.origin + $(this).attr("href");

        try {
          loading(true);
          let productRes = await getAjax(linkUrl, "GET", "html");
          let gridUpdate = $(productRes).find(".products").html();
          $(".products").html(gridUpdate);
          let facetsForm = $(productRes).find(".facets-form").html();
          $(".facets-form").html(facetsForm);

          history.replaceState(null, null, linkUrl);
          updateItemView();
          addToCartForm();
          filterLoad();
          removeFilter();
          onChangeVariantPLP();
          loading(false);
        } catch {
          console.error("Error loading more content:", error);
          loading(false);
        }
      });
    }
    // facets-form ajax START
  }

  if ($("body").hasClass("pagecart")) {
    function discountToggle() {
      if ($(".discount-main").length > 0) {
        $(".discount-main").click(function () {
          $(".discount-details").toggle();
        });
      }
    }
    discountToggle();
  }

  // Product Page
  if ($("body").hasClass("pageproduct")) {
    pdpJS();
    // Function to update bundle slider after variant change
    // Make it globally accessible
    window.updateBundleSlider = function() {
      const bundleSection = document.querySelector('.product-bundle-section');
      if (!bundleSection) {
        console.log('Bundle: No bundle section found');
        return;
      }
      
      const slider = bundleSection.querySelector('.bundle-products-slider');
      if (!slider) {
        console.log('Bundle: No slider found');
        return;
      }
      
      // Only run slider logic when Liquid says slider is enabled (more than 2 items)
      const sliderEnabledAttr = slider.getAttribute('data-slider-enabled');
      const sliderEnabled = sliderEnabledAttr === 'true' || sliderEnabledAttr === true;
      if (!sliderEnabled) {
        console.log('Bundle: Slider not enabled (<=2 items), skipping slick init');
        return;
      }
      
      console.log('Bundle: Updating slider after variant change');
      
      // Destroy existing slider if initialized
      if (slider.classList.contains('slick-initialized')) {
        if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick !== 'undefined') {
          try {
            window.jQuery(slider).slick('unslick');
            console.log('Bundle: Slider destroyed');
          } catch(e) {
            console.warn('Bundle: Error destroying slider:', e);
          }
        }
        slider.classList.remove('slick-initialized');
        slider.removeAttribute('style');
        const slickTrack = slider.querySelector('.slick-track');
        if (slickTrack) {
          const slides = slickTrack.querySelectorAll('.slick-slide');
          slides.forEach(function(slide) {
            slide.classList.remove('slick-slide');
            slide.removeAttribute('style');
            slide.removeAttribute('data-slick-index');
          });
          slickTrack.remove();
        }
      }
      
      // Reinitialize slider after a delay to ensure DOM is ready
      setTimeout(function() {
        const slickOptions = {
          arrows: true,
          prevArrow: bundleSection.querySelector('.bundle-slider-prev'),
          nextArrow: bundleSection.querySelector('.bundle-slider-next'),
          slidesToShow: 2.5,
          slidesToScroll: 1,
          infinite: false,
          draggable: true,
          swipe: true,
          touchMove: true,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2.5,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1
              }
            }
          ]
        };
        
        if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick !== 'undefined') {
          try {
            window.jQuery(slider).slick(slickOptions);
            console.log('Bundle: Slider reinitialized');
          } catch(e) {
            console.warn('Bundle: Error initializing slider:', e);
          }
        } else {
          console.warn('Bundle: jQuery or Slick not available');
        }
      }, 300);
    };

    function bindSwatchLabelClickFallback() {
      // Slick/carousel clones can duplicate radio ids. In that case label[for]
      // may toggle a hidden clone input instead of the visible one.
      // This fallback always toggles the sibling radio in the same swatch item.
      $(document)
        .off(
          "click.r2bSwatchLabel",
          ".tt-options-swatch .swatch-input__label, .variant-drawer-option-label"
        )
        .on(
          "click.r2bSwatchLabel",
          ".tt-options-swatch .swatch-input__label, .variant-drawer-option-label",
          function (e) {
            const input = this.previousElementSibling;
            if (!input || input.tagName !== "INPUT" || input.type !== "radio") {
              return;
            }
            if (input.disabled) {
              e.preventDefault();
              return;
            }
            if (!input.checked) {
              e.preventDefault();
              input.checked = true;
              input.setAttribute("checked", "checked");
              input.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        );
    }

    function syncCheckedAttributeForSwatches() {
      $(document)
        .off("change.r2bCheckedAttr", '.tt-options-swatch input[type="radio"]')
        .on("change.r2bCheckedAttr", '.tt-options-swatch input[type="radio"]', function () {
          const changedInput = this;
          const card = changedInput.closest(".rt-product-card");
          const optionIndex = changedInput.getAttribute("optionIndex");
          const name = changedInput.getAttribute("name");

          let groupSelector = null;
          if (optionIndex) {
            groupSelector = `.tt-options-swatch input[type="radio"][optionIndex="${optionIndex}"]`;
          } else if (name) {
            groupSelector = `.tt-options-swatch input[type="radio"][name="${name.replace(/"/g, '\\"')}"]`;
          }
          if (!groupSelector) return;

          const scope = card || document.querySelector(".product-main") || document;
          const radios = scope.querySelectorAll(groupSelector);
          radios.forEach((radio) => {
            if (radio === changedInput && radio.checked) {
              radio.setAttribute("checked", "checked");
            } else {
              radio.removeAttribute("checked");
            }
          });
        });
    }

    function onChangeVariant() {
      const productMainEl = document.querySelector(".product-main");
      if (!productMainEl) return;

      // Main PDP only: block clicks coming from recommended-product cards.
      $(productMainEl)
        .off("change.pdpVariant")
        .on(
          "change.pdpVariant",
          '.tt-options-swatch input[type="radio"]',
          async function () {
            if ($(this).closest(".rt-product-card").length > 0) return;

            function isValidVariantId(id) {
              return (
                id &&
                id !== "undefined" &&
                id !== "null" &&
                (typeof id !== "string" || id.trim() !== "")
              );
            }

            const mainVariantInput = document.querySelector(
              ".pdp-cart-form .add-to-cart-form [name=\"id\"]"
            );

            function getSelectedVariantIdFromOptions() {
              try {
                if (!window.productJson) return null;
                const variants = JSON.parse(window.productJson);
                const selectedValues = [];
                const requiredOptionIdxs = new Set();

                // Determine which option groups exist (option1/2/3)
                const mainPdpSwatches = Array.from(
                  productMainEl.querySelectorAll(
                    '.tt-options-swatch input[type="radio"]'
                  )
                ).filter((input) => !input.closest(".rt-product-card"));

                mainPdpSwatches.forEach((el) => {
                  const optionIndex = el.getAttribute("optionIndex");
                  if (!optionIndex) return;
                  const idx = parseInt(
                    optionIndex.replace("option", ""),
                    10
                  ) - 1;
                  if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                    requiredOptionIdxs.add(idx);
                  }
                });

                // Read all checked radios inside the PDP
                mainPdpSwatches
                  .filter((input) => input.checked)
                  .forEach((input) => {
                    const optionIndex = input.getAttribute("optionIndex");
                    const value = (input.value || "").toString();
                    if (!value) return;

                    if (optionIndex) {
                      const idx = parseInt(
                        optionIndex.replace("option", ""),
                        10
                      ) - 1;
                      if (!Number.isNaN(idx) && idx >= 0 && idx < 3) {
                        selectedValues[idx] = value;
                        return;
                      }
                    }

                    // Fallback: fill first empty slot
                    for (let i = 0; i < 3; i++) {
                      if (!selectedValues[i]) {
                        selectedValues[i] = value;
                        break;
                      }
                    }
                  });

                // Ensure all required option groups have values
                for (const idx of requiredOptionIdxs) {
                  if (!selectedValues[idx]) return null;
                }

                const normalize = (str) =>
                  (str || "").toString().trim().toLowerCase();

                const matchingVariant = variants.find((v) => {
                  if (
                    selectedValues[0] &&
                    normalize(v.option1) !== normalize(selectedValues[0])
                  )
                    return false;
                  if (
                    selectedValues[1] &&
                    normalize(v.option2) !== normalize(selectedValues[1])
                  )
                    return false;
                  if (
                    selectedValues[2] &&
                    normalize(v.option3) !== normalize(selectedValues[2])
                  )
                    return false;
                  return true;
                });

                return matchingVariant ? matchingVariant.id.toString() : null;
              } catch (e) {
                return null;
              }
            }

            const optionGroupCount = new Set(
              Array.from(
                productMainEl.querySelectorAll(
                  '.tt-options-swatch input[type="radio"][optionIndex]'
                )
              )
                .filter((input) => !input.closest(".rt-product-card"))
                .map((input) => input.getAttribute("optionIndex"))
                .filter(Boolean)
            ).size;

            const clickedVarId = $(this).attr("var_id");
            const combinedVarId = getSelectedVariantIdFromOptions();

            // Single-option products: trust clicked swatch var_id first.
            // Multi-option products: use combined option match first.
            let var_id =
              (optionGroupCount <= 1
                ? clickedVarId || combinedVarId
                : combinedVarId || clickedVarId) ||
              (document.querySelector(
                ".pdp-cart-form .add-to-cart-form [name=\"id\"]"
              )?.value ||
                document.querySelector("#product-form-atc [name=\"id\"]")
                  ?.value ||
                document.querySelector("#product-form-atc-ctm [name=\"id\"]")
                  ?.value ||
                document.querySelector(
                  ".product-main .pdp-cart-form form [name=\"id\"]"
                )?.value);

            // If variant id isn't ready yet, wait for Shopify/theme to update it.
            if (!isValidVariantId(var_id)) {
              if (mainVariantInput) {
                setTimeout(() => {
                  const finalVarId = mainVariantInput.value;
                  if (!isValidVariantId(finalVarId)) return;

                  const urlObj = new URL(window.location.href);
                  urlObj.searchParams.set("variant", finalVarId);
                  window.location.href = urlObj.toString();
                }, 150);
              }
              return;
            }

            // Hard reload: server will render the correct variant state.
            const urlObj = new URL(window.location.href);
            urlObj.searchParams.set("variant", var_id);
            const newUrl = urlObj.toString();

            try {
              if (window.__r2bVariantNavigationInFlight) return;
              window.__r2bVariantNavigationInFlight = true;
              loading(true);
              setTimeout(() => {
                window.location.href = newUrl;
              }, 150);
            } catch (e) {
              window.__r2bVariantNavigationInFlight = false;
              loading(false);
            }
          }
        );
    }

  function pdpTab() {
  
  // Global partial height for all tabs (fixed height for consistency across all products)
  var pdpGlobalPartialHeight = 250;

  /* ------------------------------
     DEFAULT TAB CLICK BEHAVIOR
  ------------------------------ */
  $(".pdp-tabs-title").click(function () {
    var $title = $(this);
    var $tabBlock = $title.closest(".pdp-tab-block");
    var $content = $title.siblings(".pdp-tabs-content");
    var isFirstTab = $tabBlock.is($(".pdp-tab-block").first());

    // Special behavior for the FIRST tab:
    // - Click on title should open to "see more" state (partial height)
    // - "See more" button then expands fully (handled in setupSeeMoreForBlock)
    if (isFirstTab) {
      var isVisible = $content.is(":visible");

      if (isVisible) {
        // Closing first tab
        $title.removeClass("active");
        $content.slideUp(function () {
          // Remove see-more button when collapsed
          $tabBlock.find(".see-more-btn").remove();

          // Reset content styles when collapsed
          var contentElement = $content[0];
          if (contentElement) {
            contentElement.style.removeProperty("max-height");
            contentElement.style.removeProperty("overflow");
          }
        });
      } else {
        // Opening first tab → go directly to partial "see more" state
        $title.addClass("active");

        // Make sure content is visible before applying partial height
        $content.show();

        // Ensure previous inline styles are cleared before re-applying
        var contentElement = $content[0];
        if (contentElement) {
          contentElement.style.removeProperty("max-height");
          contentElement.style.removeProperty("overflow");
        }

        // This will set partial height and create the "see more" button
        setupSeeMoreForBlock($tabBlock);
      }

      updateTabToggleButtons();
      return; // Skip default behavior for first tab
    }

    // Default behavior for all other tabs (no see-more logic)
    $title.toggleClass("active");

    $content.slideToggle(function () {
      if (!$content.is(":visible")) {
        // When other tabs are collapsed, just ensure any stray see-more is removed
        $tabBlock.find(".see-more-btn").remove();
      }
    });

    updateTabToggleButtons();
  });

  $(".pdp-tab-toggle-btn").click(function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $tabBlock = $(this).closest(".pdp-tab-block");
    var $title = $tabBlock.find(".pdp-tabs-title");
    var $content = $tabBlock.find(".pdp-tabs-content");
    var isFirstTab = $tabBlock.is($(".pdp-tab-block").first());
  
    // For non-first tabs: simple toggle open/closed
    if (!isFirstTab) {
      var isVisible = $content.is(":visible");
      
      if (isVisible) {
        // Closing tab
        $title.removeClass("active");
        $content.slideUp();
      } else {
        // Opening tab
        $title.addClass("active");
        $content.slideDown();
      }
      
      updateTabToggleButtons();
      return;
    }

    // For first tab: apply partial/full toggle + see-more behaviour
    var contentElement = $content[0];
    var currentMaxHeight = contentElement ? window.getComputedStyle(contentElement).maxHeight : "";
    var isFullyExpanded =
      currentMaxHeight === "none" ||
      currentMaxHeight === "" ||
      parseFloat(currentMaxHeight) > 10000;

    if (isFullyExpanded) {
      // Collapse to partial height (use fixed height for consistency)
      var fullHeight = contentElement.scrollHeight;
      var partialHeight = pdpGlobalPartialHeight;

      $content.animate(
        { "max-height": partialHeight + "px" },
        300,
        function () {
          if (contentElement) {
            contentElement.style.setProperty(
              "max-height",
              partialHeight + "px",
              "important"
            );
            contentElement.style.setProperty(
              "overflow",
              "hidden",
              "important"
            );
          }

          // Smooth scroll back to tab title after collapse animation
          if ($title.length > 0) {
            var titleOffset = $title.offset().top;
            var scrollOffset = titleOffset - 100; // Add some offset from top

            $("html, body").animate(
              { scrollTop: scrollOffset },
              400,
              "swing"
            );
          }
        }
      );

      // Recreate "see more" button if it doesn't exist
      if ($tabBlock.find(".see-more-btn").length === 0) {
        $tabBlock.append(`
          <button class="see-more-btn">
            Toon meer
          </button>
        `);

        // Attach click handler for see more button
        $tabBlock.find(".see-more-btn").off("click.seeMoreToggle").on("click.seeMoreToggle", function () {
          var $content = $tabBlock.find(".pdp-tabs-content");
          var contentElement = $content[0];
          var fullHeight = contentElement.scrollHeight;

          if (contentElement) {
            contentElement.style.setProperty(
              "max-height",
              fullHeight + "px",
              "important"
            );
            $content.animate(
              { "max-height": fullHeight + "px" },
              300,
              function () {
                contentElement.style.setProperty(
                  "max-height",
                  "none",
                  "important"
                );
              }
            );
          }
          $(this).remove();
        });
      }
    } else {
      // Expand to full height
      var fullHeight = contentElement.scrollHeight;
      if (contentElement) {
        contentElement.style.setProperty(
          "max-height",
          fullHeight + "px",
          "important"
        );
        $content.animate(
          { "max-height": fullHeight + "px" },
          300,
          function () {
            contentElement.style.setProperty(
              "max-height",
              "none",
              "important"
            );
          }
        );
      }

      // Remove "see more" button when fully expanded
      $tabBlock.find(".see-more-btn").remove();
    }
    
    $title.addClass("active");
    
    updateTabToggleButtons();
  });

  /* ------------------------------
     UPDATE MORE/LESS BUTTON TEXT
  ------------------------------ */
  function updateTabToggleButtons() {
    $(".pdp-tab-block").each(function () {
      var $tabBlock = $(this);
      var $title = $tabBlock.find(".pdp-tabs-title");
      var $content = $tabBlock.find(".pdp-tabs-content");
      var $button = $tabBlock.find(".pdp-tab-toggle-btn");
      var $buttonText = $button.find(".pdp-tab-toggle-text");

      if ($title.hasClass("active") && $content.is(":visible")) {
        $button.show();
        $buttonText.text($buttonText.data("show-less") || "Show less");
        $button.attr("aria-label", $buttonText.data("show-less") || "Show less");
      } else {
        $button.hide();
        $buttonText.text($buttonText.data("show-more") || "Show more");
        $button.attr("aria-label", $buttonText.data("show-more") || "Show more");
      }
    });
  }

  /* ------------------------------
     SETUP SEE-MORE FOR ANY TAB
  ------------------------------ */
  function setupSeeMoreForBlock($tabBlock) {
    var $content = $tabBlock.find(".pdp-tabs-content");
    var $title = $tabBlock.find(".pdp-tabs-title");

    if ($content.length === 0) return;

    var contentElement = $content[0];
    if (!contentElement) return;

    var fullHeight = contentElement.scrollHeight || $content.prop("scrollHeight");
    
    // Use fixed partial height for all tabs (consistent across all products)
    var partialHeight = pdpGlobalPartialHeight;

    // Apply partial open styles
    contentElement.style.setProperty("max-height", partialHeight + "px", "important");
    contentElement.style.setProperty("overflow", "hidden", "important");

    // Mark tab title as active to reflect open state
    $title.addClass("active");

    // Create SEE MORE button if it doesn't exist yet
    if ($tabBlock.find(".see-more-btn").length === 0) {
      $tabBlock.append(`
        <button class="see-more-btn">
          Toon meer
        </button>
      `);
    }

    // SEE MORE click → expand fully
    $tabBlock.find(".see-more-btn").off("click.seeMore").on("click.seeMore", function () {
      var contentElement = $content[0];
      if (contentElement) {
        var fullHeight = contentElement.scrollHeight;
        contentElement.style.setProperty("max-height", fullHeight + "px", "important");
        $content.animate(
          { "max-height": fullHeight + "px" },
          300,
          function () {
            contentElement.style.setProperty("max-height", "none", "important");
          }
        );
      } else {
        $content.animate(
          { "max-height": fullHeight + "px" },
          300,
          function () {
            $content.css("max-height", "none");
          }
        );
      }

      $(this).remove(); // Remove after expansion
    });
  }

  /* ------------------------------------------
     INIT VISIBLE TABS WITH PARTIAL OPEN + SEE MORE
  ------------------------------------------ */
  function initVisibleTabsPartialOpen() {
    // Ensure the FIRST tab (description) and the LAST tab (e.g. recommendations) are open on load;
    // all middle tabs are closed.
    var $allTabs = $(".pdp-tab-block");
    if ($allTabs.length === 0) return;

    var lastIndex = $allTabs.length - 1;

    $allTabs.each(function (index) {
      var $tabBlock = $(this);
      var $content = $tabBlock.find(".pdp-tabs-content");
      var $title = $tabBlock.find(".pdp-tabs-title");

      if (index === 0 || index === lastIndex) {
        // First and last tab: open and mark active
        $title.addClass("active");
        $content.show();
      } else {
        // All middle tabs (e.g. Reviews, Additional info, etc.): closed on load
        $title.removeClass("active");
        $content.hide();
      }
    });

    // Apply see-more functionality to the first (now-open) tab
    var $firstTab = $allTabs.first();
    if ($firstTab.length > 0) {
      setupSeeMoreForBlock($firstTab);
    }
  }

  // Initialize on page load - use setTimeout to ensure DOM is ready
  setTimeout(function() {
    initVisibleTabsPartialOpen();
    updateTabToggleButtons();
    
    // Recalculate after images/content load (in case height changes) - only for first tab
    setTimeout(function() {
      var $firstTab = $(".pdp-tab-block").first();
      if ($firstTab.length > 0) {
        var $content = $firstTab.find(".pdp-tabs-content");
        if ($content.length > 0 && $content.is(":visible") && $firstTab.find(".see-more-btn").length > 0) {
          var contentElement = $content[0];
          if (contentElement) {
            var fullHeight = contentElement.scrollHeight;
            
            // Use fixed partial height for consistency
            var partialHeight = pdpGlobalPartialHeight;
            contentElement.style.setProperty("max-height", partialHeight + "px", "important");
          }
        }
      }
    }, 500);
  }, 100);
}


    function pdpImageSlider() {
      $("#aniimated-thumbnials").lightGallery({
         selector: 'a',
        thumbnail: true,
        subHtmlSelectorRelative: false,
        getCaptionFromTitleOrAlt: false,
        autoplay: false,
        download: false,
        zoom: false,
        fullScreen: false,
        share: false,
        counter: false,
        videojs: true,       // required for HTML5 + YouTube/Vimeo
        youtubePlayerParams: {
          modestbranding: 1,
          showinfo: 0,
          rel: 0,
          controls: 1
        },
        vimeoPlayerParams: {
          byline : 0,
          portrait : 0,
          color : 'A90707'
        }
      });
      $('#aniimated-thumbnials').on('onAfterOpen.lg', function () {
          $('.lg-autoplay-button').remove();
      });

    $(document).ready(function () {
      $(".media-video-featured").each(function () {

        var $wrapper = $(this);
        var $video = $wrapper.find("video");
        var $button = $wrapper.find(".video-play-btn");
        var $preview = $wrapper.find(".media-preview-image");

        if (!$video.length || !$button.length) return;

        var vid = $video[0];

        // Save original Play SVG from HTML
        var playIcon = $button.html();

        // Pause SVG
        var pauseIcon = `
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 5h4v14H6zm8 0h4v14h-4z"/>
          </svg>
        `;

        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        $button.on("click", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          // Pause other videos
          $("video").each(function () {
            if (this !== vid) {
              this.pause();
              this.currentTime = 0;
            }
          });

          if (vid.paused) {

            if (!isMobile) {
              if (vid.requestFullscreen) vid.requestFullscreen();
              else if (vid.webkitRequestFullscreen) vid.webkitRequestFullscreen();
              else if (vid.msRequestFullscreen) vid.msRequestFullscreen();
            }

            vid.play();

          } else {
            vid.pause();
          }
        });

        // When video plays
        $video.on("play", function () {
          $wrapper.addClass("played-video");
          $preview.hide();
          $button.html(pauseIcon); // Switch to Pause icon
        });

        // When video pauses or ends
        $video.on("pause ended", function () {
          $wrapper.removeClass("played-video");
          $preview.show();
          $button.html(playIcon); // Switch back to Play icon
        });
    });


  /* Pause video on slide change */
  $('.product__main-carousel').on('beforeChange', function () {
    $("video").each(function () {
      this.pause();
      this.currentTime = 0;
    });
  });


  /* Pause if fullscreen exits */
  $(document).on(
    "fullscreenchange webkitfullscreenchange msfullscreenchange",
    function () {
      if (
        !document.fullscreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        $("video").each(function () {
          this.pause();
        });
      }
    }
  );

});





      var $carousel = $(".slider-for");
      $carousel.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        infinite: false,
        asNavFor: ".slider-nav",
        adaptiveHeight: true,
        draggable: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: false,
              fade: true,
              swipe: true,
              touchMove: true,
              draggable: true
            }
          }
        ]
      });
      $(".slider-nav").slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: ".slider-for",
        dots: false,
        infinite: false,
        focusOnSelect: true,
        draggable: true,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              draggable: true,
              swipe: true,
              touchMove: true,
            },
          },
        ],
      });
    }
  }
  function initStickyATCWrapper() {
    // Re-initialize sticky ATC wrapper after AJAX updates
    const stickyAtc = document.getElementById("stickyAtcWrapper");
    const originalAtc = document.querySelector("#originalAtcWrapper button[type='submit']");
    const productForm = document.getElementById("product-form-atc");
    const stickyBtn = document.querySelector(".sticky-atc-btn");

    if (stickyAtc && originalAtc && stickyBtn && productForm) {
      // Disconnect any existing observer
      if (window.stickyATCObserver) {
        window.stickyATCObserver.disconnect();
      }

      // Create new IntersectionObserver to detect original button visibility
      window.stickyATCObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              stickyAtc.classList.remove("show");
            } else {
              stickyAtc.classList.add("show");
            }
          });
        },
        { threshold: 0.1 }
      );
      window.stickyATCObserver.observe(originalAtc);

      // Remove old event listeners and add new ones
      const newStickyBtn = stickyBtn.cloneNode(true);
      stickyBtn.parentNode.replaceChild(newStickyBtn, stickyBtn);
      
      // Sticky button triggers original form submit
      newStickyBtn.addEventListener("click", function() {
        productForm.requestSubmit();
      });
    }
  }

  function updateStickyATCPrice() {
    if (window.productJson) {
      try {
        // Get the current variant ID from the main product form
        const productForm = $(".pdp-cart-form form, form.add-to-cart-form, form[id*='product-form']").first();
        let variantId = null;
        
        if (productForm.length > 0) {
          const variantInput = productForm.find('input[name="id"]');
          if (variantInput.length > 0 && variantInput.val()) {
            variantId = variantInput.val();
          }
        }
        
        // If no variant ID from main form, try to get from sticky ATC form
        if (!variantId) {
          const stickyForm = $("#bottom-sticky-cta-section form");
          if (stickyForm.length > 0) {
            const stickyVariantInput = stickyForm.find('input[name="id"]');
            if (stickyVariantInput.length > 0 && stickyVariantInput.val()) {
              variantId = stickyVariantInput.val();
            }
          }
        }
        
        // If no variant ID from forms, try to get from selected options (main product swatches)
        if (!variantId) {
          const selectedOptions = {};
          $('.tt-options-swatch input[type="radio"]:checked').each(function() {
            const optionName = $(this).attr('name');
            const optionValue = $(this).val();
            const optionIndex = $(this).attr('optionIndex');
            if (optionIndex) {
              selectedOptions[optionIndex] = optionValue;
            }
          });
          
          if (Object.keys(selectedOptions).length > 0) {
            const variantsJSON = JSON.parse(window.productJson);
            const matchingVariant = $.grep(variantsJSON, function (variant) {
              return $.map(selectedOptions, function (value, optionName) {
                return variant[optionName] === value;
              }).every(Boolean);
            })[0];
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
            }
          }
        }
        
        // If still no variant ID, try to get from sticky ATC dropdowns
        if (!variantId) {
          const stickySelectedOptions = {};
          $("#bottom-sticky-cta-section .select__select").each(function() {
            const optionIndex = $(this).attr('optionIndex');
            const selectedValue = $(this).val();
            if (optionIndex && selectedValue) {
              stickySelectedOptions[optionIndex] = selectedValue;
            }
          });
          
          if (Object.keys(stickySelectedOptions).length > 0) {
            const variantsJSON = JSON.parse(window.productJson);
            const matchingVariant = $.grep(variantsJSON, function (variant) {
              return $.map(stickySelectedOptions, function (value, optionName) {
                return variant[optionName] === value;
              }).every(Boolean);
            })[0];
            
            if (matchingVariant) {
              variantId = matchingVariant.id;
            }
          }
        }
        
        // Update price if we have a variant ID
        if (variantId && window.productJson) {
          const variantsJSON = JSON.parse(window.productJson);
          const variant = variantsJSON.find(function(v) {
            return v.id == variantId || v.id.toString() === variantId.toString();
          });
          
          if (variant) {
            const price = getItemFormatedPrice(variant.price);
            const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price 
              ? getItemFormatedPrice(variant.compare_at_price) 
              : null;
            
            // Update bottom sticky ATC price (.fixed-product-price)
            if ($("#bottom-sticky-cta-section").length > 0) {
              const priceElement = $("#bottom-sticky-cta-section .fixed-product-price, #sticky-atc-price");
              if (priceElement.length > 0) {
                // Use IDs if available, otherwise fall back to HTML replacement
                const priceCurrent = $("#sticky-atc-price-current");
                const priceCompare = $("#sticky-atc-price-compare");
                
                if (priceCurrent.length > 0) {
                  priceCurrent.text(price);
                  
                  if (comparePrice && priceCompare.length > 0) {
                    priceCompare.text(comparePrice);
                    priceCompare.show();
                  } else if (priceCompare.length > 0) {
                    priceCompare.hide();
                  } else if (comparePrice) {
                    // If compare price element doesn't exist but we have a compare price, add it
                    priceCurrent.after(' <del id="sticky-atc-price-compare">' + comparePrice + '</del>');
                  }
                } else {
                  // Fallback to HTML replacement if IDs don't exist
                  if (comparePrice) {
                    priceElement.html('<span id="sticky-atc-price-current">' + price + '</span> <del id="sticky-atc-price-compare">' + comparePrice + '</del>');
                  } else {
                    priceElement.html('<span id="sticky-atc-price-current">' + price + '</span>');
                  }
                }
                
                // Also update the variant ID in the sticky ATC form
                const stickyForm = $("#bottom-sticky-cta-section form");
                if (stickyForm.length > 0) {
                  let stickyVariantInput = stickyForm.find('input[name="id"]');
                  if (stickyVariantInput.length === 0) {
                    stickyForm.append('<input type="hidden" name="id" value="' + variant.id + '">');
                  } else {
                    stickyVariantInput.val(variant.id);
                  }
                }
              }
            }
            
            // Update sticky ATC wrapper price (.product-price_wrapper.ctm)
            if ($("#stickyAtcWrapper").length > 0) {
              const priceCurrent = $("#stickyAtcWrapper #product-price-current");
              const priceCompare = $("#stickyAtcWrapper #product-price-compare");
              
              if (priceCurrent.length > 0) {
                priceCurrent.text(price);
                
                if (comparePrice && priceCompare.length > 0) {
                  priceCompare.text(comparePrice);
                  priceCompare.show();
                } else if (priceCompare.length > 0) {
                  priceCompare.hide();
                }
              }
            }
          }
        }
      } catch (error) {
        console.warn("Error updating sticky ATC price:", error);
      }
    }
  }

  function stickyATC() {
    if ($("#bottom-sticky-cta-section").length > 0) {
      $("#bottom-sticky-cta-section .select__select").change(async function () {
        let selectedOptions = {};
        let selectedValue = $(this).val();
        let optionIndex = $(this).attr("optionIndex");
        selectedOptions[optionIndex] = selectedValue;
        const variantsJSON = JSON.parse(window.productJson);
        const matchingVariant = $.grep(variantsJSON, function (variant) {
          return $.map(selectedOptions, function (value, optionName) {
            return variant[optionName] === value;
          }).every(Boolean);
        })[0];
        let urlObj = new URL(window.location.href);
        urlObj.searchParams.set("variant", matchingVariant.id);
        let newUrl = urlObj.toString();
        try {
          let response = await getAjax(newUrl, "GET", "html");
          const stickyATCLayout = $(response)
            .find("#bottom-sticky-cta-section")
            .html();
          $("#bottom-sticky-cta-section").html(stickyATCLayout);
          actionStickyATC();
          onStickyQtyChange();
          stickyATC();
          // Update price after AJAX update
          setTimeout(function() {
            updateStickyATCPrice();
          }, 200);
        } catch {}
      });
      const actualATC = $(".pdp-cart-form");
      const stickyATC = $("#bottom-sticky-cta-section");
      const top = actualATC.offset().top;

      const stickyATCscrollHandler = (event) => {
        const y = $(document).scrollTop();
        const windowHeight = $(window).height();
        const documentHeight = $(document).height();

        // Check if recommended products tab is active/visible
        const recommendedProductsTab = $('.pdp-tabs-title.active');
        const isRecommendedProductsActive = recommendedProductsTab.length > 0 && 
          recommendedProductsTab.text().toLowerCase().includes('recommended') ||
          recommendedProductsTab.text().toLowerCase().includes('aanbevolen') ||
          recommendedProductsTab.text().toLowerCase().includes('vergelijkbaar');
        
        // Check if recommended products content is visible
        const recommendedProductsContent = $('.recommended-products-grid').closest('.pdp-tabs-content');
        const isRecommendedProductsVisible = recommendedProductsContent.length > 0 && 
          recommendedProductsContent.is(':visible') && 
          recommendedProductsContent.css('display') !== 'none';

        // Hide sticky bar when recommended products are visible
        if (isRecommendedProductsActive || isRecommendedProductsVisible) {
          stickyATC.removeClass("sticky-atc");
          return;
        }

        if (y >= top && y + windowHeight < documentHeight) {
          stickyATC.addClass("sticky-atc");
        } else {
          stickyATC.removeClass("sticky-atc");
        }
      };

      $(window).on("scroll", stickyATCscrollHandler);
    }
  }

  function onStickyQtyChange() {
    if ($(".sticky-qty-wrapper .sticky-qty-btn").length > 0) {
      $(".sticky-qty-wrapper .sticky-qty-btn").click(async function () {
        const inputQty = $(this).parent().find("input.sticky-qty-input_box");
        const currentQty = parseInt(inputQty.val());

        if ($(this).hasClass("plus-btn")) {
          inputQty.val(Math.max(currentQty + 1, 1));
        } else {
          inputQty.val(Math.max(currentQty - 1, 1));
        }
      });
    }
  }

  function actionStickyATC() {
    if ($("#bottom-sticky-cta-section").length > 0) {
      $("#bottom-sticky-cta-section .sticky-atc-form").submit(async function (
        event
      ) {
        event.preventDefault();
        try {
          loading(true);
          const response = await postAjax(
            "/cart/add.js",
            "POST",
            "json",
            $(this).serialize()
          );
          const itemImageUrl = response.featured_image.url;
          const itemTitle = response.title;
          const itemQty = response.quantity;
          const itemTotalPrice = getItemFormatedPrice(response.price);
          const cartQty =
            parseInt(window.cart.quantity) +
            parseInt($(this).find(".sticky-qty-value").val());
          const cartTotalPriceWithoutFormatedPrice =
            parseInt(window.cart.total_price) +
            parseInt(response.price) *
              parseInt($(this).find(".sticky-qty-value").val());
          const cartTotalPrice = getItemFormatedPrice(
            cartTotalPriceWithoutFormatedPrice
          );
          await layoutUpdate();
          $("#modal-addtocart .addtocart-product img").attr(
            "src",
            itemImageUrl
          );
          $("#modal-addtocart .addtocart-product product-title").text(
            itemTitle
          );
          $("#modal-addtocart .addtocart-product .addtocart-qty .count").text(
            itemQty
          );
          $("#modal-addtocart .product-cart-total .price-amt").text(
            itemTotalPrice
          );
          $(
            "#modal-addtocart .product-cart-price-total .modal-total-quantity"
          ).text(cartQty);
          $("#modal-addtocart .product-cart-price-total .price").text(
            cartTotalPrice
          );
          setTimeout(function () {
            window.cart.quantity = cartQty;
            window.cart.total_price = cartTotalPriceWithoutFormatedPrice;
            removeFromCartForm();
            loading(false);
            $("#modal-addtocart").addClass("active");
            if ($("#modal-addtocart").hasClass("active")) {
              $(".modal-addtocart-header .close").click(function () {
                $("#modal-addtocart").removeClass("active");
              });
            }
          }, 1000);
          console.log("Added item to cart....!");
        } catch {}
      });
    }
  }
  function addToCartFormRecommandation() {
    $(document)
      .off("submit.r2bRec", ".product-recommendations .add-to-cart-form")
      .on(
        "submit.r2bRec",
        ".product-recommendations .add-to-cart-form",
        async function (event) {
      event.preventDefault();
      try {
        // Ensure the correct variant id is used for this specific card.
        // Recommended cards contain swatch radios; depending on timing, the hidden
        // input[name="id"] can remain on the default variant. We correct it
        // right before submitting using the currently checked radio in the same card.
        try {
          const resolvedVariantId = resolveSelectedVariantId(this);
          if (resolvedVariantId) {
            $(this).find('input[name="id"]').val(resolvedVariantId);
          }
        } catch (e) {}

        loading(true);
        const response = await postAjax(
          "/cart/add.js",
          "POST",
          "json",
          $(this).serialize()
        );
        const itemImageUrl = response.featured_image.url;
        const itemTitle = response.title;
        const itemQty = response.quantity;
        const itemTotalPrice = getItemFormatedPrice(response.price);
        const cartQty =
          parseInt(window.cart.quantity) +
          parseInt($(this).find(".qty-value").val());
        const cartTotalPriceWithoutFormatedPrice =
          parseInt(window.cart.total_price) +
          parseInt(response.price) * parseInt($(this).find(".qty-value").val());
        const cartTotalPrice = getItemFormatedPrice(
          cartTotalPriceWithoutFormatedPrice
        );
        await layoutUpdate();
        $("#modal-addtocart .addtocart-product img").attr("src", itemImageUrl);
        $("#modal-addtocart .addtocart-product product-title").text(itemTitle);
        $("#modal-addtocart .addtocart-product .addtocart-qty .count").text(
          itemQty
        );
        $("#modal-addtocart .product-cart-total .price-amt").text(
          itemTotalPrice
        );
        $(
          "#modal-addtocart .product-cart-price-total .modal-total-quantity"
        ).text(cartQty);
        $("#modal-addtocart .product-cart-price-total .price").text(
          cartTotalPrice
        );
        setTimeout(function () {
          window.cart.quantity = cartQty;
          window.cart.total_price = cartTotalPriceWithoutFormatedPrice;
          removeFromCartForm();
          loading(false);
          $("#modal-addtocart").addClass("active");
          if ($("#modal-addtocart").hasClass("active")) {
            $(".modal-addtocart-header .close").click(function () {
              $("#modal-addtocart").removeClass("active");
            });
          }
        }, 1000);
        console.log("Added item to cart....!");
      } catch (error) {
        console.error("Error loading more content:", error);
        loading(false);
      }
    });
  }
  function pdpJS() {
    bindSwatchLabelClickFallback();
    syncCheckedAttributeForSwatches();
    onChangeVariant();
    pdpTab();
    pdpImageSlider();
    stickyATC();
    actionStickyATC();
    onStickyQtyChange();

    function getMainPdpAtcForm$() {
      const $a = $("#product-form-atc");
      if ($a.length) return $a;
      const $b = $("#product-form-atc-ctm");
      if ($b.length) return $b;
      return $(".product-main .pdp-cart-form form").first();
    }

    // Listen for variant changes to update sticky ATC price
    $(window).off('variant:change.stickyATC').on('variant:change.stickyATC', function() {
      setTimeout(function() {
        updateStickyATCPrice();
        // Also sync the variant ID in sticky form
        syncStickyFormVariant();
      }, 100);
    });
    // Main PDP ATC only — avoid matching recommendation / collection card forms
    getMainPdpAtcForm$()
      .off('change.stickyATC')
      .on('change.stickyATC', 'input[name="id"]', function() {
      setTimeout(function() {
        updateStickyATCPrice();
        // Also sync the variant ID in sticky form
        syncStickyFormVariant();
      }, 100);
    });
    
    // Function to sync variant ID from main form to sticky form
    function syncStickyFormVariant() {
      const mainForm = getMainPdpAtcForm$();
      const stickyForm = $("#bottom-sticky-cta-section form");
      
      if (mainForm.length > 0 && stickyForm.length > 0) {
        const mainVariantInput = mainForm.find('input[name="id"]');
        const stickyVariantInput = stickyForm.find('input[name="id"]');
        
        if (mainVariantInput.length > 0 && mainVariantInput.val()) {
          if (stickyVariantInput.length === 0) {
            stickyForm.append('<input type="hidden" name="id" value="' + mainVariantInput.val() + '">');
          } else {
            stickyVariantInput.val(mainVariantInput.val());
          }
        }
      }
    }
    
    // Watch for variant input changes using MutationObserver
    if (typeof MutationObserver !== 'undefined') {
      const mainForm = getMainPdpAtcForm$();
      if (mainForm.length > 0) {
        const variantInput = mainForm.find('input[name="id"]')[0];
        if (variantInput) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                setTimeout(function() {
                  updateStickyATCPrice();
                  syncStickyFormVariant();
                }, 100);
              }
            });
          });
          observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
        }
      }
    }
    
    // Update sticky ATC price on initial load
    updateStickyATCPrice();
    syncStickyFormVariant();
    if(typeof Globo != 'undefined' && typeof Globo?.Preorder != 'undefined') Globo?.Preorder?.initPreorder()
    addToCartFormRecommandation();
    setTimeout(function () {
      updateStickyATCPrice();
    }, 2000);
  }

  function loading(bool) {
    if (bool) {
      $("#r2b-loader").show();
      $("html").addClass("rt-loading");
    } else {
      $("#r2b-loader").hide();
      $("html").removeClass("rt-loading");
    }
  }

  function getItemFormatedPrice(price) {
    const currencies_using_comma_decimals =
      "ANG,ARS,BRL,BYN,BYR,CLF,CLP,COP,CRC,CZK,DKK,EUR,HRK,HUF,IDR,ISK,MZN,NOK,PLN,RON,RUB,SEK,UYU,VES,VND";
    let formattedPrice;
    if (
      currencies_using_comma_decimals.includes(window.shop.currencyCode.trim())
    ) {
      formattedPrice = (price / 100).toFixed(2).replace(".", ",");
    } else {
      formattedPrice = (price / 100).toFixed(2);
    }
    return window.shop.currencySymbol + formattedPrice;
  }
});